import http from "../axios/http-common";

class InterfaceAsesmenRalan {
  // getAsesmenRalan(unit, reg) {
  //   return http.getData(`/unit/${unit}/register/${reg}/asesment`);
  // }

  getAsesmenAwalRalan(unit, reg) {
    return http.getData(`/asesmen-awal-ralan/unit/${unit}/register/${reg}`);
  }

  // getAsesmenRalanByID(id) {
  //   return http.getData(`/asesment/${id}`);
  // }

  // cetakPdfAsesmenRalan(id) {
  //   return http.getData(`/asesment/${id}/pdf-auth`);
  // }

  cetakPdfAsesmenAwalRalan(id) {
    return http.getData(`/asesmen-awal-ralan/${id}/pdf`);
  }

  checkStatusAsesmenRalan(unitId, rm, registerId) {
    // return http.getData(`/pasien/${rm}/asesmen-awal-ralan/cek-alert`);
    return http.getData(
      `/asesmen-awal-ralan/cek-alert/unit/${unitId}/pasien/${rm}/register/${registerId}`
    );
  }

  // saveAsesmenRalan(
  //   reg,
  //   rm,
  //   unit_id,
  //   user_id,
  //   dokter_id,
  //   perawat_id,
  //   kronis
  // ) {
  //   return http.postData(`/asesment`, {
  //     register_id: reg,
  //     pasien_rm: rm,
  //     unit_id: unit_id,
  //     user_id: user_id,
  //     dokter_id: dokter_id,
  //     perawat_id: perawat_id,
  //     kronis: kronis
  //   });
  // }

  // editAsesmenRalan(
  //   id,
  //   reg,
  //   rm,
  //   unit_id,
  //   user_id,
  //   dokter_id,
  //   perawat_id,
  //   kronis
  // ) {
  //   return http.putData(`/asesment/${id}`, {
  //     register_id: reg,
  //     pasien_rm: rm,
  //     unit_id: unit_id,
  //     user_id: user_id,
  //     dokter_id: dokter_id,
  //     perawat_id: perawat_id,
  //     kronis: kronis
  //   });
  // }

  saveAsesmenRalanKeperawatan(reg, rm, unit_id, user_id, param) {
    return http.postData(`/asesmen-awal-ralan-keperawatan`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      // alergi: param['anamnesis']['alergi'],
      alergi: param["alergi"],
      riwayat_perawatan_sebelum: param["riwayat_perawatan_sebelum"],
      diagnosis_perawat: param["diagnosis_perawat"],
      tindakan_perawat: param["tindakan_perawat"],
      mual: param["mual"],
      muntah: param["muntah"],
      perawat_id: user_id,
      anamnesis: {
        keluhan: param["anamnesis"]["keluhan"],
        riwayat_penyakit: param["riwayat_perawatan_sebelum"], //ambit dr riwayat perawatan sebelumnya
        status_psikologis_id: param["anamnesis"]["status_psikologis_id"],
        status_psikologis_text: param["anamnesis"]["status_psikologis_text"]
      },
      tanda_vital: {
        sistole: param["tanda_vital"]["sistole"],
        diastole: param["tanda_vital"]["diastole"],
        frekuensi_nadi: param["tanda_vital"]["frekuensi_nadi"],
        frekuensi_nafas: param["tanda_vital"]["frekuensi_nafas"],
        suhu_badan: param["tanda_vital"]["suhu_badan"],
        saturasi_oksigen: param["tanda_vital"]["saturasi_oksigen"],
        keadaan_umum: param["tanda_vital"]["keadaan_umum"],
        kesadaran: param["tanda_vital"]["kesadaran"]
      },
      antropometri: {
        berat_badan: param["antropometri"]["berat_badan"],
        tinggi_badan: param["antropometri"]["tinggi_badan"],
        lingkar_kepala: param["antropometri"]["lingkar_kepala"],
        lla: param["antropometri"]["lla"]
        // imt: param['antropometri']['imt'],
      },
      risiko_jatuh: param["risiko_jatuh"],
      fungsional: {
        alat_bantu: param["fungsional"]["alat_bantu"],
        prothesa: param["fungsional"]["prothesa"],
        cacat_tubuh: param["fungsional"]["cacat_tubuh"],
        adl: param["fungsional"]["adl"]
      },
      nyeri: {
        skala: param["nyeri"]["skala"],
        lokasi: param["nyeri"]["lokasi"],
        // intensitas: param['nyeri']['intensitas'],
        durasi: param["nyeri"]["durasi"],
        frekuensi: param["nyeri"]["frekuensi"],
        pencetus: param["nyeri"]["pencetus"],
        kualitas: param["nyeri"]["kualitas"],
        pola_serangan: param["nyeri"]["pola_serangan"],
        penyebab_hilang: param["nyeri"]["penyebab_hilang"],
        jenis: param["nyeri"]["jenis"]
      },
      hambatan_budaya: param["hambatan"]
    });
  }

  editAsesmenRalanKeperawatan(id, reg, rm, unit_id, user_id, param) {
    return http.putData(`/asesmen-awal-ralan-keperawatan/${id}`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      // alergi: param['anamnesis']['alergi'],
      alergi: param["alergi"],
      riwayat_perawatan_sebelum: param["riwayat_perawatan_sebelum"],
      diagnosis_perawat: param["diagnosis_perawat"],
      tindakan_perawat: param["tindakan_perawat"],
      mual: param["mual"],
      muntah: param["muntah"],
      perawat_id: user_id,
      anamnesis: {
        id: param["anamnesis"]["id"],
        keluhan: param["anamnesis"]["keluhan"],
        riwayat_penyakit: param["riwayat_perawatan_sebelum"], //ambit dr riwayat perawatan sebelumnya
        status_psikologis_id: param["anamnesis"]["status_psikologis_id"],
        status_psikologis_text: param["anamnesis"]["status_psikologis_text"]
      },
      tanda_vital: {
        id: param["tanda_vital"]["id"],
        sistole: param["tanda_vital"]["sistole"],
        diastole: param["tanda_vital"]["diastole"],
        frekuensi_nadi: param["tanda_vital"]["frekuensi_nadi"],
        frekuensi_nafas: param["tanda_vital"]["frekuensi_nafas"],
        suhu_badan: param["tanda_vital"]["suhu_badan"],
        saturasi_oksigen: param["tanda_vital"]["saturasi_oksigen"],
        keadaan_umum: param["tanda_vital"]["keadaan_umum"],
        kesadaran: param["tanda_vital"]["kesadaran"]
      },
      antropometri: {
        id: param["antropometri"]["id"],
        berat_badan: param["antropometri"]["berat_badan"],
        tinggi_badan: param["antropometri"]["tinggi_badan"],
        lingkar_kepala: param["antropometri"]["lingkar_kepala"],
        lla: param["antropometri"]["lla"]
        // imt: param['antropometri']['imt'],
      },
      risiko_jatuh: param["risiko_jatuh"],
      fungsional: {
        id: param["fungsional"]["id"],
        alat_bantu: param["fungsional"]["alat_bantu"],
        prothesa: param["fungsional"]["prothesa"],
        cacat_tubuh: param["fungsional"]["cacat_tubuh"],
        adl: param["fungsional"]["adl"]
      },
      nyeri: {
        id: param["nyeri"]["id"],
        skala: param["nyeri"]["skala"],
        lokasi: param["nyeri"]["lokasi"],
        // intensitas: param['nyeri']['intensitas'],
        durasi: param["nyeri"]["durasi"],
        frekuensi: param["nyeri"]["frekuensi"],
        pencetus: param["nyeri"]["pencetus"],
        kualitas: param["nyeri"]["kualitas"],
        pola_serangan: param["nyeri"]["pola_serangan"],
        penyebab_hilang: param["nyeri"]["penyebab_hilang"],
        jenis: param["nyeri"]["jenis"]
      },
      hambatan_budaya: param["hambatan"]
    });
  }

  saveAsesmenRalanMedis(reg, rm, unit_id, user_id, param) {
    return http.postData(`/asesmen-awal-ralan-medis`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      keluhan_utama_medis: param["keluhan_utama_medis"],
      riwayat_penyakit_sekarang: param["riwayat_penyakit_sekarang"],
      status_lokalis: {
        catatan: param["status_lokalis"]["catatan"],
        gambar: param["status_lokalis"]["gambar"]
      },
      penunjang: param["penunjang"],
      diagnosis_medis: param["diagnosis_medis"],
      tindakan_medis: param["tindakan_medis"],
      dokter_id: user_id,
      kronis: param["kronis"]
    });
  }

  editAsesmenRalanMedis(id, reg, rm, unit_id, user_id, param) {
    return http.putData(`/asesmen-awal-ralan-medis/${id}`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      keluhan_utama_medis: param["keluhan_utama_medis"],
      riwayat_penyakit_sekarang: param["riwayat_penyakit_sekarang"],
      status_lokalis: {
        id: param["status_lokalis"]["id"],
        catatan: param["status_lokalis"]["catatan"],
        gambar: param["status_lokalis"]["gambar"]
      },
      penunjang: param["penunjang"],
      diagnosis_medis: param["diagnosis_medis"],
      tindakan_medis: param["tindakan_medis"],
      dokter_id: user_id,
      kronis: param["kronis"]
    });
  }

  print(id) {
    window.open(`${http.getAPI()}/asesmen-awal-ralan/${id}/pdf`, "_blank");
  }
}
export default new InterfaceAsesmenRalan();
